import CardHover from '@/components/CardHover/CardHover'
import { CardsInDeckType } from '@/types/deck'
import { formatUrl } from '@/utils/helpers'

import styles from './DeckCategory.module.scss'

const countCards = (cards: CardsInDeckType[]) => cards.reduce((acc, { cardcount }) => acc + parseInt(cardcount), 0)

type Props = {
  cards: CardsInDeckType[]
  header: string
  setCurrentImage: (arg: string) => void
}

const DeckCategory = ({ cards, header, setCurrentImage }: Props) => (
  <div>
    {/* Don't render if empty string */}
    {header && (
      <h4>
        {header} ({countCards(cards)})
      </h4>
    )}
    <ul className='p-0'>
      {cards.map(({ cardcount, cardname }) => (
        <li className={styles.listItem} key={cardname}>
          <span>{cardcount} </span>
          <span onMouseOver={() => setCurrentImage(cardname)}>
            <CardHover mobileOnly name={cardname.split('|')[0]} url={`/cards/${formatUrl(cardname.split('|')[0])}`} />
          </span>
        </li>
      ))}
    </ul>
  </div>
)

export default DeckCategory
